import { getApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

let analyticsInstance = null;

export const initAnalytics = () => {
  if (analyticsInstance) return analyticsInstance;
  try {
    const app = getApp();
    analyticsInstance = getAnalytics(app);
    return analyticsInstance;
  } catch {
    return null;
  }
};
